import React from "react";
import { createRoot } from "react-dom/client";
export default function renderDashboard(dashboard, containerId = "dashboard-mount-point") {
    const container = document.getElementById(containerId);
    if (container) {
        const root = createRoot(container);
        root.render(React.createElement(React.StrictMode, {}, dashboard));
    }
}
